import { render, staticRenderFns } from "./FormError.vue?vue&type=template&id=049511bb&scoped=true&"
import script from "./FormError.vue?vue&type=script&lang=ts&"
export * from "./FormError.vue?vue&type=script&lang=ts&"
import style0 from "./FormError.vue?vue&type=style&index=0&id=049511bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049511bb",
  null
  
)

export default component.exports